import { BrandWordmark } from './BrandWordmark.js'
import { ThemeToggle } from './ThemeToggle.js'

/**
 * Header — the molecule.dev landing nav language: dark bar with a hairline
 * bottom border, the gradient wordmark lockup on the left, and the theme
 * toggle plus an external link on the right. This app is unauthenticated, so
 * there is no account menu or auth CTA.
 */
export function Header() {
  return (
    <header className="mol-header" data-mol-id="brand-header">
      <div
        style={{
          maxWidth: 1080,
          margin: '0 auto',
          padding: '14px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
        }}
      >
        <a href="/" style={{ textDecoration: 'none' }} aria-label="Molecule.dev Status home">
          <BrandWordmark suffix="Status" size={20} />
        </a>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <a
            className="mol-btn"
            href="https://www.molecule.dev"
            target="_blank"
            rel="noopener noreferrer"
            data-mol-id="header-molecule-link"
          >
            molecule.dev ↗
          </a>
          <ThemeToggle />
        </div>
      </div>
    </header>
  )
}
